import { DatePipe } from "@angular/common";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "@app/core";
import { BaseControl, ConfirmComponent, Const, Documento, Forma, HistorialDocumento, Static, Tarea, UsuarioActual } from "@app/shared";
import { environment } from "@env/environment";
import { find } from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subject, Subscription } from "rxjs";
import { SpecialRadicationConfig } from "./shared/special-radication-config.service";
import { SpecialRadicationForm } from "./shared/special-radication-form.service";
import { ScannerServiceSpecialRadication } from "./shared/special-radication-scanner.service";
import { DocumentAnnulation, SpecialRadicationDataService, Dependencie, previewSticker } from "./shared/special-radication.data.service";

@Component({
  selector: "iw-special-radication",
  templateUrl: "./special-radication.component.html",
  styleUrls: ["./special-radication.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [SpecialRadicationForm, SpecialRadicationDataService, ScannerServiceSpecialRadication],
})
export class SpecialRadicationComponent implements OnInit, OnDestroy {
  // Define si la tarea está finalizada
  @Input() finishTask: boolean
  // Define si el usuario entró por el ícono Lápiz (modificar radicación)
  @Input() modify: boolean = false;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // Variable a la cual se le injectan las configuraciones de la tabla.
  settings = {};
  // Configuraciones de la tabla de stickers
  settingsStickers = {};
  // Datos de la tabla de stickers
  sourceDataStickers: LocalDataSource;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // contiene los documentos de la tarea
  source: Array<Documento> = [];
  // Datos para historial de documentos
  sourceDataHistoryModify: LocalDataSource;
  // condiguracion tabla de historial de documentos
  settingsHistoryModify = {};
  //modal
  modalRef: BsModalRef;
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Validar si se generó el radicado
  radicated = false;
  // datos de la fila seleccionada
  rowSelected: any = {};
  // nomber de radicado
  nombre_documental: any;
  // número de radicado
  numero_radicado: any;
  // fecha del radicado
  fecha_radicado: any;
  // hora del radicado
  hora: any;
  // Label de extensiones para el accept del campo
  extensionsAccept = "";
  //activa la funcion de descargar
  disabledDowload = false;
  uploadRequerid = false;
  // Almacena los documentos que se van a subir.
  documentsUpload: any[] = [];
  // Define cuando esta subiendo un documento
  isLoading = false;
  // variable que contiene toda la data del documento.
  formData = new FormData();
  //define si el radicado está anulado
  annul: boolean = false;
  // Contiene el usuario en sesion
  user: UsuarioActual;
  // Define el responsable de la tarea
  responsable: 'asignado' | 'sin_asignar' | 'no_asignado' = 'sin_asignar';
  // contiene la información de la anulación
  annulInformation: DocumentAnnulation;
  // define si el usuario está viendo la anulación
  watchingAnnulation: boolean = false;
  // Informacion de la fila seleccionada de la tabla de docuemntos modificados
  rowSelectModify: any = null;
  // Label de las extensiones permitidas
  @Input() extensionsLabel = "jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif";
  // Tarea actual
  @Input() task: Tarea;
  // Forma de la tarea
  @Input() form: Forma;
  // Oculta o muestra el boton de regresar
  @Input() single = true;
  // Oculta o muestra el titulo del componente
  @Input() title: Boolean = true;
  // Variable que contendrá los documentos.
  documents: Array<Documento> = [];
  // Variable que valida los tipos de documentos que se pueden subir
  @Input() extensions: string[] = [
    "image/tiff-fx",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/pdf",
    "image/jpg",
    "image/png",
    "image/jpeg",
    "image/tif",
    "image/tiff",
  ];
  // Evento que emite al presionar el boton de cerrar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // controla la finalización de la tarea
  @Output() validRadication: EventEmitter<boolean> = new EventEmitter();
  // Notifica la actualizacion de informacion de la tarea
  @Output() taskUpdate: EventEmitter<Partial<Tarea>> = new EventEmitter();
  //Referencia al modal personalizado
  @ViewChild("modalDetail") modalDetail: any;
  // Referencia al modal de stickers
  @ViewChild("modalStickers") modalStickers: any;
  // Referencia al modal de anular
  @ViewChild("modalAnnul") modalAnnul: any;
  //Referencia al modal de subir documentos
  @ViewChild("template") templateDocuments: any;
  //Referencia al modal de subir documentos pdf e insertar sticker
  @ViewChild("templateInjectSticker") templateDocumentsPdf: any;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewModifyDoc') private templatePreviewModifyDoc: TemplateRef<any>;
  // Referencia al template de la modal de historial de modificaciones de documento
  @ViewChild('historyModify') private historyModify: TemplateRef<any>;
  //Emisor de anulacion correcta
  @Output() anulation: EventEmitter<boolean> = new EventEmitter<boolean>();
  // Datos de ejemplo para llenar la tabla de stickers
  dataTable: any[] = [];
  // numero de documentos a validar
  numberDocuments = 0;
  // lista de dependencias para el control
  list: Dependencie[] = [];
  // Referencia a la dependencia seleccionada
  selectedDependencie: any;
  // Referencia al sticker seleccionado
  selectedSticker: any;
  // define si muestra o no el selector de rotulos
  selectedOptionSticker: any;
  // define si muestra o no el selector de dependencias
  selectorDependencia = false;
  // define si muestra o no el selector de rotulos
  selectorStickers = false;
  // define si activa o no el boton radicar
  canRadicate = false;
  //Datos de ejemplo para llenar la tabla inicial
  tableList = [{ serie: "Prueba", subserie: "Prueba sub", tipo_documental: "documental" }];
  // listado de opciones
  listOptions = [{ id: 1, nombre: 'Sí' }, { id: 2, nombre: 'No' }];
  // Indica si esta activada la radicación avanzada
  advancedFiling = environment.radicacionAvanzada;
  // Configuracion de la radicación avanzada
  advancedFilingConfig = environment.confRadicacionAvanzada;
  // Campos de la radicación avanzada
  advancedFilingFields: any[] = [];
  // Datos del documento radicado
  filingData: any = {};
  // Indica si esta activada la radicación avanzada
  advancedFilingCustom = false;
  // Indica si esta activada la radicación avanzada
  typeAdvancedFilingCustom: any = null;
  // Indica si esta activada la radicación avanzada
  advancedFilingCustomConfig: any[] = [];
  // Indica si esta activada la radicación avanzada
  advancedFilingCustomData: any = {};
  // varible que controla el boton de subir documento
  uploadButton: boolean = true;
  // varible que controla el boton de generar documento
  generateButton: boolean = false;
  // Variable que controla el encendido / apagado del boton para anular
  specialRadication: boolean = environment.specialAnulationRadication;
  // controla el boton de visualizar documento
  viewDoc: boolean = false;
  // Datos de ejemplo para llenar el selector de stickers
  selectorDataSticker: any[] = [];
  // controla el boton de generar rotulos
  // disabledStamp:boolean = false;
  activateAction = {
    delete: true
  }
  // configuracion del servicio de sockets
  titleSocket: any = 'socketrv';
  content: any = '1100';
  received: any = [];
  sent: any = [];
  scannBtn = true;
  // Identifica si la tarea esta en modo carga de datos
  loadTask = false;
  // label para modal de carga de datos
  labelDocument: any = "";
  activeHistoryModify = false;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewDocScanned') private templatePreviewDocScanned: TemplateRef<any>;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;
  // Referencia al template de la modal carga al generar
  @ViewChild('templateLoadGenerationRadication') private templateLoadingGenerationRadication: TemplateRef<any>;
  // Referencia al template de la modal de stickers
  @ViewChild('templateInjectStickerScann') private templateStikersDocScanned: TemplateRef<any>;

  controlGenerate: boolean = false;
  // Variable que contendrá el formulario de fechas.
  formGenerateManual: FormGroup = new FormGroup({
    dependenciaRadicado: new FormControl(null, [Validators.required]),
    radicate: new FormControl('', [Validators.required]),
    dateRadicate: new FormControl(null, [Validators.required]),
  });

  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  private searchEventSubscription: Subscription;


  constructor(
    private modal: BsModalService,
    private srfs: SpecialRadicationForm,
    private srds: SpecialRadicationDataService,
    private toastr: ToastrService,
    private as: AuthenticationService,
    private datePipe: DatePipe,
    private scannerServiceR: ScannerServiceSpecialRadication
  ) {
    this.advancedFilingFields = this.getAdvancedFilingFields();
  }

  ngOnInit() {
    if (this.previewFlow) {
      this.finishTask = true;
    }
    this.user = this.as.getCredentials();
    if (this.task && this.task.responsables && this.task.responsables.length) {
      if (this.user) {
        const assigned = find(this.task.responsables, { id: this.user.user_id });
        if (assigned) {
          this.responsable = 'asignado';
        } else {
          this.responsable = 'no_asignado';
        }
      } else {
        this.responsable = 'no_asignado';
      }
    }
    const docsC = new SpecialRadicationConfig();
    this.settings = docsC.settings;
    this.settingsStickers = docsC.settingsStickers;
    this.loadingDocs();
    this.controls = this.srfs.getForm();
    // this.validateNumberRadication();
    // this.validateRadicated();
    this.selectorDependencia = this.form.estilo.solicitar_dependencias_radicacion_especial;
    this.canRadicate = !this.selectorDependencia;
    this.getDependencie();
    //Validación d epermiso si variable de entorno specialRadicacion esta activa
    if (this.specialRadication) {
      // Conexion con el permiso
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.instanceProcess,
        Const.types_action_permissions.deleteSettled
      )
    }
    if (environment.previsulizacionDocumentos) {
      this.viewDoc = true;
    }
    if (environment.EscanerDocumentos && this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.escanear) {
      this.searchEventSubscription = this.scannerServiceR.messages.subscribe(msg => {
        if (this.modalRef) {
          this.modalRef.hide()
        }
        var file = new Blob([msg], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        this.modalRef = this.modal.show(this.templatePreviewDocScanned, { class: 'modal-personalized', ignoreBackdropClick: true });
        let type = "pdf";
        let documentModal = { "tipo": type, "ruta": fileURL, "blob_file": file }
        this.modalRef.content = documentModal;
      });
    } else {
      this.scannBtn = false;
    }
    // valida si la forma de la tarea tienen la opcion de previsualizador de sticker
    if (this.task.tarea_forma && this.task.tarea_forma.length && this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.previewSticker) {
      this.advancedFilingCustom = this.task.tarea_forma[0].parametros.previewSticker;
      this.typeAdvancedFilingCustom = this.task.tarea_forma[0].parametros.typePreviewSticker;
    }
    if (this.task && this.task.carga && !this.radicated) {
      this.loadTask = true;
    }
    if (environment.showHistoryModificationDocument) {
      this.activeHistoryModify = environment.showHistoryModificationDocument;
    }
  }

  ngOnDestroy() {
    if (environment.EscanerDocumentos && this.searchEventSubscription) {
      this.searchEventSubscription.unsubscribe();
    }
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Obtiene las dependencias
   *
   * @memberof SpecialRadicationComponent
   */
  getDependencie() {
    this.srds.getDependencies().subscribe(async res => {
      if (res) {
        this.list = await res;
      }
    });
  }

  validateRadicated() {
    // let radicated = false;
    // this.task.documentos.forEach(doc=>{
    //   if(doc.documentos_detalle.length){
    //     if(doc.documentos_detalle[0].radicado){
    //       radicated = true;
    //     }
    //   }
    // })
    // if(radicated){
    //   this.validRadication.emit(true);
    //   this.close.emit(true);
    // }

  }

  loadingDocs() {
    if (this.task.documentos.length) {
      this.task.documentos.forEach((document) => {
        document.funciones.forEach((funcion) => {
          if (
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.radication ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.generate ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.dowload ||
            funcion.funcion === Const.DOCUMENTS_FUNCTIONS.insertSticker
          ) {
            // const existDocument = find(this.source, {
            //   clasificacion_id: document.clasificacion_id,
            //   idtarea: this.task.id,
            // });
            const existDocument = find(this.source, {
              id_tipo_documental: document.id_tipo_documental,
              idtarea: this.task.id,
            });
            if (!existDocument) {
              const doc: Documento = document;
              doc.idtarea = this.task.id;
              this.source.push(doc);
              this.documents.push(doc);
            }
          }
        });
        if (document.documentos_detalle.length) {
          if (document.documentos_detalle[0].historial && document.documentos_detalle[0].historial.length) {
            this.disabledDowload = true;
          }
          this.nombre_documental = document.tipo_documental;
          this.numero_radicado = document.documentos_detalle[0].radicado;
          this.fecha_radicado = document.documentos_detalle[0].fecha;
          this.hora = document.documentos_detalle[0].fecha;
          this.selectedDependencie = document.documentos_detalle[0].id_dependencia;
          if (document.documentos_detalle && document.documentos_detalle[0].radicado) {
            this.radicated = true;
            this.setFilingData(document.documentos_detalle[0], this.nombre_documental);
          }
        }
      });
    }
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
  }

  /**
   *Valida que el número de documentos subidos sea igual a los solicitados
   *
   * @return {*} 
   * @memberof SpecialRadicationComponent
   */
  validateNumberRadication() {
    this.numberDocuments = this.form.estilo.numeros_documentos;
    let contador = 0;
    let cumple = false;
    this.task.documentos.forEach(doc => {
      if (doc.documentos_detalle.length && doc.documentos_detalle[0].radicado !== ('' || null)) {
        contador++;
      }
    })
    if (contador == this.numberDocuments) {
      cumple = true;
    } else {
      cumple = false;
    }
    return cumple;
  }

  /**
   *Controla cuando el usuario da click sobre la tabla
   *
   * @param {*} data
   * @memberof SpecialRadicationComponent
   */
  clikRowSelect(data: any) {
    if (data.data.documentos_detalle && data.data.documentos_detalle.length) {
      this.srds.getAnnulation(data.data.documentos_detalle[0].id_documento).subscribe(res => {
        if (res) {
          if (res.id) {
            this.annul = true;
            this.annulInformation = res;
            let values: any = {
              fecha_anulacion: this.annulInformation.fecha,
              motivo: this.annulInformation.motivo
            }
            this.controls = this.srfs.getForm(values);
          } else {
            this.annul = false;
          }
        }
      })
    }
    if (this.advancedFilingCustom) {
      this.srds.getPreviewRadication(this.task.id, this.typeAdvancedFilingCustom, data.data.id_tipo_documental).subscribe(res => {
        if (res) {
          this.advancedFilingCustomConfig = res.estructura.sort((a, b) => a.orden - b.orden);
          this.advancedFilingCustomData = res.valores;
        }
      })
    }
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
    if (data.data.funciones) {
      const existFuction: any = find(data.data.funciones, {
        funcion: Const.DOCUMENTS_FUNCTIONS.upload
      });
      if (!existFuction) {
        this.disabledDowload = true;
        this.uploadButton = false;
      } else {
        this.uploadRequerid = existFuction.obligatorio;
      }
      const existGenerateDocument: any = find(data.data.funciones, {
        funcion: Const.DOCUMENTS_FUNCTIONS.generate
      });
      if (existGenerateDocument) {
        this.generateButton = true;
      }
      // if(existIncertSticker){
      //   this.disabledStamp = true;
      // }else{
      //   this.disabledStamp = false;
      // }
    }
    this.rowSelected = data;
    if (this.rowSelected.data && this.rowSelected.data.mostrar_radicado_tipo_documental == true) {
      this.labelDocument = this.rowSelected.data.tipo_documental;
    } else if (this.rowSelected.data && this.rowSelected.data.mostrar_radicado_sub_serie == true) {
      this.labelDocument = this.rowSelected.data.Subserie;
    } else if (this.rowSelected.data && this.rowSelected.data.mostrar_radicado_serie == true) {
      this.labelDocument = this.rowSelected.data.Serie;
    }
  }


  /**
   *Detecta los cambios en la dependencia
   *
   * @param {*} data
   * @memberof CopyToComponent
   */
  changeDependencie(data: any) {
    this.selectedDependencie = data;
    if (this.selectedDependencie !== null && this.selectorDependencia) {
      this.canRadicate = true;
    } else {
      this.canRadicate = false;
    }
  }

  /**
   *Emite el evento de cerrar la tarea
   *
   * @memberof SpecialRadicationComponent
   */
  closeComponent() {
    this.close.emit(true);
  }

  /**
   *Revisa si el documento tiene historial
   *
   * @memberof SpecialRadicationComponent
   */
  checkHistorial() {
    return this.rowSelected.data ? this.rowSelected.data.documentos_detalle.length ? this.rowSelected.data.documentos_detalle[0].historial ? this.rowSelected.data.documentos_detalle[0].historial.length : false : false : false;
  }

  closeModalDetail() {
    if (this.radicated && ((this.disabledDowload && this.uploadRequerid) || (!this.disabledDowload && !this.uploadRequerid) || (this.disabledDowload && !this.uploadRequerid))) {
      this.validRadication.emit(true);
      this.close.emit(true);
      this.closeModal();

    } else if (this.finishTask == false && this.disabledDowload == false && this.uploadButton && this.radicated && !this.annul) {
      // this.closeModal();
      this.toastr.warning('Recuerde subir el documento radicado', 'Recomendación');
    } else {
      this.closeModal();
      // Solo emite la alerta si no se ha finalizado
      if (this.finishTask == false && !this.annul && this.radicated == false) {
        this.toastr.warning('Recuerde radicar el documento', 'Recomendación');
      }
    }
    if (this.annul) {
      this.closeModal();
    }
  }


  downloadDocument() {
    this.srds.downloadDocument(this.rowSelected.data.documentos_detalle[0].id_documento).subscribe(res => {
      if (res) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
      }
    })
  }

  /**
   *Cierra la modal
   *
   * @memberof SpecialRadicationComponent
   */
  closeModal() {
    this.modalRef.hide();
  }

  /**
   *Abre la modal de rótulos
   *
   * @memberof SpecialRadicationComponent
   */
  openModalStickers() {
    this.closeModal();
    this.modalRef = this.modal.show(this.modalStickers, {
      class: "modal-medium-personalized",
      ignoreBackdropClick: true,
    });
    this.dataTable.length = 0;
    this.srds.getStickers(this.rowSelected.data.id_tipo_documental).subscribe(async (res) => {
      if (res) {
        res.forEach(async (r) => {
          if (r.imprimir) {
            let name = await r.nombre;
            let tipo_documental = null;
            if (r.tipo_documental) {
              tipo_documental = await r.tipo_documental.nombre;
            }
            let item = {
              id: r.id,
              nombre: name,
              tipo_documental: tipo_documental,
              documentos_detalle: this.rowSelected.data.documentos_detalle,
              funciones: this.rowSelected.data.funciones,
              value: true
            };
            this.dataTable.push(item);
          }
        });
        this.sourceDataStickers = new LocalDataSource(this.dataTable);
      }
    });
  }

  /**
   *Cierra la modal de rótulos
   *
   * @memberof SpecialRadicationComponent
   */
  closeModalStickers() {
    this.closeModal();
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }

  /**
   *Abre la modal de anular
   *
   * @memberof SpecialRadicationComponent
   */
  openAnnulModal() {
    this.closeModal();
    this.modalRef = this.modal.show(this.modalAnnul, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
    if (this.annul) {
      this.watchingAnnulation = true;
    }
  }

  /**
   *Cierra la modal de anular
   *
   * @memberof SpecialRadicationComponent
   */
  async closeModalAnnul() {
    this.closeModal();
    if (!this.annul || this.watchingAnnulation) {
      this.modalRef = await this.modal.show(this.modalDetail, {
        class: "modal-lg-personalized",
        ignoreBackdropClick: true,
      });
    } else {
      if (!this.watchingAnnulation) {
        await this.anulation.emit(true);
      }
    }
  }

  /**
   *Controla los cambios en el control del modal de anular
   *
   * @param {*} data
   * @memberof SpecialRadicationComponent
   */
  sended(data: any) {
    // this.srds.annulation(this.task.id, this.rowSelected.data.documentos_detalle[0].id_documento,
    //   "documento", data.dpicker, data.textarea).subscribe(async res => {
    //     if (res) {
    //       this.annul = true;
    //       //esperar que se cierre la modal de anulación
    //       await this.closeModalAnnul();
    //     } else {
    //       this.closeModalAnnul();
    //       this.toastr.warning('No se pudo anular el radicado', 'Error en la acción');
    //     }
    //   })

    //Verificacion de variable de entorno
    if (this.specialRadication) {
      //Verificación de permiso
      if (this.activateAction.delete) {
        this.srds.annulation(this.task.id, this.rowSelected.data.documentos_detalle[0].id_documento,
          "documento", data.dpicker, data.textarea).subscribe(async res => {
            if (res) {
              this.annul = true;
              //esperar que se cierre la modal de anulación
              await this.closeModalAnnul();
            } else {
              this.closeModalAnnul();
              this.toastr.warning('No se pudo anular el radicado', 'Error en la acción');
            }
          })
      } else {
        this.toastr.warning('Usted no tiene permisos para anular radicados del sistema', 'Error en la acción');
      }
    } else {
      // Si variable de entorno se encuentra apagada
      this.srds.annulation(this.task.id, this.rowSelected.data.documentos_detalle[0].id_documento,
        "documento", data.dpicker, data.textarea).subscribe(async res => {
          if (res) {
            this.annul = true;
            //esperar que se cierre la modal de anulación
            await this.closeModalAnnul();
          } else {
            this.closeModalAnnul();
            this.toastr.warning('No se pudo anular el radicado', 'Error en la acción');
          }
        })
    }

  }

  /**
   *Finaliza la radicación especial y pasa a la siguiente pestaña
   *
   * @memberof SpecialRadicationComponent
   */
  async endSpecial() {
    if (this.rowSelected.data) {
      this.controlGenerate = true;
      if (this.modalRef) {
        this.modalRef.hide();
      }
      this.modalRef = this.modal.show(this.templateLoadingGenerationRadication, {
        class: 'modal-dialog-centered', ignoreBackdropClick: true,
        initialState: this.rowSelected.data
      });
      setTimeout(() => {
        let formData = null;
        if (this.selectorDependencia) {
          formData = {
            folios: 0,
            tarea: this.rowSelected.data.idtarea,
            tipo_documental: this.rowSelected.data.id_tipo_documental,
            id_dependencia: this.selectedDependencie,
          };
        } else {
          formData = {
            folios: 0,
            tarea: this.rowSelected.data.idtarea,
            tipo_documental: this.rowSelected.data.id_tipo_documental,
          };
        }
        if (this.task.tarea_forma[0].parametros && this.task.tarea_forma[0].parametros.generarQR) {
          formData['generarQR'] = true;
          formData['tipoQR'] = this.task.tarea_forma[0].parametros.qr_tipos;
          if (this.task.tarea_forma[0].parametros.qr_categoria) {
            formData['categoriaQR'] = this.task.tarea_forma[0].parametros.qr_categoria;
          }
        }
        if (this.loadTask) {
          formData['id_dependencia'] = this.selectedDependencie;
          formData['radicado'] = this.formGenerateManual.controls['radicate'].value;
          formData['fecha'] = this.formGenerateManual.controls['dateRadicate'].value;
        }
        this.srds.generateRadication(formData).then((res) => {
          if (res) {
            this.radicated = true;
            this.loadTask = false;
            this.task.documentos.forEach((t) => {
              if (t.id_tipo_documental == res.tipo_documental) {
                if (t.documentos_detalle.length) {
                  t.documentos_detalle[0].fecha = res.fecha;
                  t.documentos_detalle[0].folios = res.folios;
                  t.documentos_detalle[0].radicado = res.radicado;
                  t.documentos_detalle[0].id_dependencia = res.id_dependencia;
                } else {
                  let item = {}

                  if (this.advancedFiling) {
                    item = {
                      fecha: res.fecha,
                      folios: res.folios,
                      radicado: res.radicado,
                      nombre: "",
                      id_documento: res.id,
                      id_dependencia: res.id_dependencia,
                      ...res
                    }
                  } else {
                    item = {
                      fecha: res.fecha,
                      folios: res.folios,
                      radicado: res.radicado,
                      nombre: "",
                      id_documento: res.id,
                      id_dependencia: res.id_dependencia,
                    };
                  }

                  let name = "";
                  this.task.documentos.forEach((doc) => {
                    if (doc.id_tipo_documental == res.tipo_documental) {
                      name = doc.tipo_documental;
                    }
                  });
                  this.nombre_documental = name;
                  this.numero_radicado = res.radicado;
                  this.fecha_radicado = res.fecha;
                  this.hora = res.fecha;
                  this.selectedDependencie = res.id_dependencia;
                  this.setFilingData(res, this.nombre_documental);
                  t.documentos_detalle.push(item);
                }
              }
            });
            this.source.length = 0;
            this.sourceData.refresh();
            this.modalRef.hide();
            this.loadingDocs();
            this.controlGenerate = false;
            if (this.advancedFilingCustom) {
              this.srds.getPreviewRadication(this.task.id, this.typeAdvancedFilingCustom, this.rowSelected.data.id_tipo_documental).subscribe(res => {
                if (res) {
                  this.advancedFilingCustomConfig = res.estructura.sort((a, b) => a.orden - b.orden);
                  this.advancedFilingCustomData = res.valores;
                }
              })
            }
            this.modalRef = this.modal.show(this.modalDetail, {
              class: "modal-lg-personalized",
              ignoreBackdropClick: true,
            });

          }
        });
      }, 500);
      this.controlGenerate = false;
    }
  }

  openGenerationRad() {
    this.modalRef = this.modal.show(this.templateLoadingGenerationRadication, {
      class: 'modal-dialog-centered', ignoreBackdropClick: true,
      initialState: this.rowSelected.data
    });
    return this.modalRef;
  }

  /**
   *Controla las acciones del componente de documentos
   *
   * @param {*} data
   * @return {*}  {*}
   * @memberof SpecialRadicationComponent
   */
  onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved(data);
    }
  }

  /**
   *Abre la modal de subir documento
   *
   * @memberof SpecialRadicationComponent
   */
  openModalDocuments() {
    this.closeModal();
    let checkFuction = find(this.rowSelected.data.funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.insertSticker })
    if (checkFuction) {
      this.selectedSticker = null;
      this.selectorDataSticker.length = 0;
      this.srds.getStickers(this.rowSelected.data.id_tipo_documental).subscribe(async (res) => {
        if (res) {
          res.forEach(async (r) => {
            if (!r.imprimir) {
              let name = await r.nombre;
              let item = {
                id: r.id,
                nombre: name,
              };
              this.selectorDataSticker.push(item);
            }
          });
        }
        this.modalRef = this.modal.show(this.templateDocumentsPdf, {
          class: "modal-lg-personalized",
          ignoreBackdropClick: true,
        });
      });
    } else {
      this.modalRef = this.modal.show(this.templateDocuments, {
        class: "modal-lg-personalized",
        ignoreBackdropClick: true,
      });
    }

  }

  /**
   *Cierra la modal de subir documentos
   *
   * @memberof SpecialRadicationComponent
   */
  closeDocumentsModal() {
    this.closeModal();
    this.documentsUpload = [];
    this.selectedOptionSticker = null;
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }

  /**
   *Sube el documento al sistema y crea un nuevo historial
   *
   * @return {*}  {*}
   * @memberof SpecialRadicationComponent
   */
  uploadDocs(insertStickers: boolean = false): any {
    if (this.documentsUpload && this.documentsUpload.length) {
      this.isLoading = true;
      let idtarea = this.task.id;
      this.formData.append("documentos", JSON.stringify(this.documentsUpload));
      this.formData.append("id_tarea", JSON.stringify(idtarea));
      if (insertStickers) {
        if (this.selectedSticker && ((this.selectedOptionSticker && this.selectedOptionSticker == 1) || this.task.carga)) {
          this.formData.append("insertar_sticker", JSON.stringify(true));
          this.formData.append("stiker_id", JSON.stringify(this.selectedSticker));
          let aux = this.documents;
          this.srds.uploadFile(this.formData).subscribe(
            async (res: any) => {
              if (!this.disabledDowload) {
                this.disabledDowload = !this.disabledDowload;
              }
              this.isLoading = false;
              if (res.length === 0) {
                console.error("Fallo del sistema");
              } else {
                this.documentsUpload = [];
                res.forEach((element: any) => {
                  if (element.tipo_documento_id == this.rowSelected.data.id_tipo_documental) {
                    if (this.rowSelected.data.documentos_detalle.length) {
                      if (this.rowSelected.data.documentos_detalle[0].historial) {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial.push(historyDocument);
                      } else {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial = [historyDocument];
                      }
                    }
                  }
                });
                this.formData = new FormData();
                this.sourceData.refresh();
                await this.updateTask();
                this.closeDocumentsModal();
              }
              this.selectedOptionSticker = null;
            },
            (err) => {
              this.isLoading = false;
            }
          );
          this.formData = null;
        } else if (this.task.carga && !this.selectedSticker) {
          // this.formData.append("insertar_sticker", JSON.stringify(true));
          // this.formData.append("stiker_id", JSON.stringify(this.selectedSticker));
          let aux = this.documents;
          this.srds.uploadFile(this.formData).subscribe(
            async (res: any) => {
              if (!this.disabledDowload) {
                this.disabledDowload = !this.disabledDowload;
              }
              this.isLoading = false;
              if (res.length === 0) {
                console.error("Fallo del sistema");
              } else {
                this.documentsUpload = [];
                res.forEach((element: any) => {
                  if (element.tipo_documento_id == this.rowSelected.data.id_tipo_documental) {
                    if (this.rowSelected.data.documentos_detalle.length) {
                      if (this.rowSelected.data.documentos_detalle[0].historial) {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial.push(historyDocument);
                      } else {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial = [historyDocument];
                      }
                    }
                  }
                });
                this.formData = new FormData();
                this.sourceData.refresh();
                await this.updateTask();
                this.closeDocumentsModal();
              }
            },
            (err) => {
              this.isLoading = false;
            }
          );
          this.formData = null;
        } else if (this.selectedOptionSticker && this.selectedOptionSticker == 2) {
          let aux = this.documents;
          this.srds.uploadFile(this.formData).subscribe(
            async (res: any) => {
              if (!this.disabledDowload) {
                this.disabledDowload = !this.disabledDowload;
              }
              this.isLoading = false;
              if (res.length === 0) {
                console.error("Fallo del sistema");
              } else {
                this.documentsUpload = [];
                res.forEach((element: any) => {
                  if (element.tipo_documento_id == this.rowSelected.data.id_tipo_documental) {
                    if (this.rowSelected.data.documentos_detalle.length) {
                      if (this.rowSelected.data.documentos_detalle[0].historial) {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial.push(historyDocument);
                      } else {
                        let historyDocument: HistorialDocumento = {
                          id: element["id"],
                          nombre: element["nombre"],
                          nombre_archivo: element["nombre_archivo"],
                          extension: element["extension"],
                          version: element["version"],
                          revision: [],
                          radicado: element["radicado"],
                        };
                        this.rowSelected.data.documentos_detalle[0].historial = [historyDocument];
                      }
                    }
                  }
                });
                this.formData = new FormData();
                this.sourceData.refresh();
                await this.updateTask();
                this.closeDocumentsModal();
              }
              this.selectedOptionSticker = null;
            },
            (err) => {
              this.isLoading = false;
            }
          );
        }
        else {
          this.toastr.warning("Debe ingresar todos los campos obligatorios", "Información faltante");
          this.isLoading = false;
        }
      } else {
        let aux = this.documents;
        this.srds.uploadFile(this.formData).subscribe(
          async (res: any) => {
            if (!this.disabledDowload) {
              this.disabledDowload = !this.disabledDowload;
            }
            this.isLoading = false;
            if (res.length === 0) {
              console.error("Fallo del sistema");
            } else {
              this.documentsUpload = [];
              res.forEach((element: any) => {
                if (element.tipo_documento_id == this.rowSelected.data.id_tipo_documental) {
                  if (this.rowSelected.data.documentos_detalle.length) {
                    if (this.rowSelected.data.documentos_detalle[0].historial) {
                      let historyDocument: HistorialDocumento = {
                        id: element["id"],
                        nombre: element["nombre"],
                        nombre_archivo: element["nombre_archivo"],
                        extension: element["extension"],
                        version: element["version"],
                        revision: [],
                        radicado: element["radicado"],
                      };
                      this.rowSelected.data.documentos_detalle[0].historial.push(historyDocument);
                    } else {
                      let historyDocument: HistorialDocumento = {
                        id: element["id"],
                        nombre: element["nombre"],
                        nombre_archivo: element["nombre_archivo"],
                        extension: element["extension"],
                        version: element["version"],
                        revision: [],
                        radicado: element["radicado"],
                      };
                      this.rowSelected.data.documentos_detalle[0].historial = [historyDocument];
                    }
                  }
                }
              });
              this.formData = new FormData();
              this.sourceData.refresh();
              await this.updateTask();
              this.closeDocumentsModal();
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }

    } else {
      this.formData = null;
    }

  }

  /**
   *Actualiza la tarea después de subir el documento
   *
   * @memberof SpecialRadicationComponent
   */
  updateTask() {
    this.task.documentos.forEach(doc => {
      if (doc.id_tipo_documental == this.rowSelected.data.id_tipo_documental) {
        doc = this.rowSelected;
        this.taskUpdate.emit(this.task);
      }
    })
  }

  /**
   * Controla las acciones del componente de documentos
   *
   * @private
   * @param {*} data
   * @return {*}  {*}
   * @memberof SpecialRadicationComponent
   */
  private onAdded(data: any): any {
    let replace = false;
    this.formData.append(data.file.name, data.file);
    if (!replace) {
      const dataD = {
        file: data.file.name,
        id_tarea: this.rowSelected.data.idtarea,
        clasificacion: "",
        tipo_documento_id: this.rowSelected.data.id_tipo_documental,
        id_documento: this.rowSelected.data.documentos_detalle[0].id_documento,
        radicado: this.rowSelected.data.documentos_detalle[0].radicado,
      };
      this.documentsUpload.push(dataD);
    }
  }

  /**
   * Remueve el documento precargado
   *
   * @private
   * @param {*} data
   * @return {*}  {*}
   * @memberof SpecialRadicationComponent
   */
  private onRemoved(data: any): any {
    this.formData.delete(data.file.name);
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]["file"] === data.file.name) {
        this.documentsUpload.splice(i, 1);
      }
    }
  }

  downloadSticker(data: any) {
    this.srds.downloadSticker(this.task.id, data.data.id).subscribe(res => {
      if (res) {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.body.url.path;
        a.download = res.body.url.name;
        a.click();
        a.remove();
        this.closeModalStickers();
      }
    })
  }

  getAdvancedFilingFields() {
    if (!this.advancedFiling) {
      return [];
    }
    // Se obtienen las filas eliminando duplicados
    const rows = Array.from(new Set(this.advancedFilingConfig.inputs.filter(i => i.mostrar).map(i => i.orden).sort()));
    const fields: any[] = [];
    // Se obtienen los campos por cada fila
    rows.forEach(row => {
      fields.push({
        first: this.getFieldByRowAndPosition(row, 1),
        second: this.getFieldByRowAndPosition(row, 2),
        third: this.getFieldByRowAndPosition(row, 3)
      });
    });
    return fields;
  }

  private getFieldByRowAndPosition(row: number, position: number) {
    return this.advancedFilingConfig.inputs.find(f => f.posicion === position && f.orden === row && f.mostrar);
  }

  private setFilingData(data: any, document_type: string) {
    if (this.advancedFiling) {
      this.filingData = {
        ...{},
        ...data
      };
      let fecha = this.datePipe.transform(data.fecha, 'dd/MM/yyyy');
      const timeField = this.advancedFilingConfig.inputs.find(i => i.key === 'hora');
      if (this.advancedFilingConfig.combinar_hora) {
        fecha = this.datePipe.transform(data.fecha, 'dd/MM/yyyy h:mm a');
        if (timeField.mostrar === true) {
          timeField.mostrar = false;
          this.advancedFilingFields = this.getAdvancedFilingFields();
        }
      } else {
        const hora = this.datePipe.transform(data.fecha, 'h:mm a');
        this.filingData.hora = hora;
        if (timeField.mostrar === false) {
          timeField.mostrar = true;
          this.advancedFilingFields = this.getAdvancedFilingFields();
        }
      }
      this.filingData.fecha = fecha;
      this.filingData.tipo_documental = document_type;
    }
  }
  /**
     * Visualizar el archivo del documento selecionado
     *
     * @private
     * @param {*} 
     * @returns {*}
     * @memberof SpecialRadicationComponent
     */
  viewDocument(): any {
    this.srds.downloadDocument(this.rowSelected.data.documentos_detalle[0].id_documento, true).subscribe(res => {
      if (res) {
        this.closeModal();
        this.modalRef = this.modal.show(this.templatePreviewDoc, { class: 'modal-personalized', initialState: res.file });
        let type = res.file.path.split(".").pop();
        let document = {
          "tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url=" + res.file.path + "&embedded=true",
          "rutaMicrosoft": "https://view.officeapps.live.com/op/view.aspx?src=" + res.file.path + "&wdOrigin=BROWSELINK"
        }
        this.modalRef.content = document;
      }
    })
  }
  /**
     * cierra el modal con el la previsualizacion de documento
     *
     * @memberof SpecialRadicationComponent
     */
  closeModalPreviewDoc() {
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }

  /**
   *Detecta los cambios en el rotulo
   *
   * @param {*} data
   * @memberof SpecialRadicationComponent
   */
  changeSticker(data: any) {
    if (data && this.selectedSticker != data.id) {
      this.selectedSticker = data.id;
    }
    // if (this.selectedSticker !== null && this.selectorStickers) {
    //   this.canRadicate = true;
    // } else {
    //   this.canRadicate = false;
    // }
  }

  /**
   *Detecta los cambios en el selector de confirmacion de sticker 
   *
   * @param {*} data
   * @memberof SpecialRadicationComponent
   */
  changeOptionSticker(data: any) {
    if (data && this.selectedOptionSticker != data.id) {
      this.selectedOptionSticker = data.id;
    }
  }


  scann() {
    let message = {
      source: '',
      content: '1100'
    };
    message.source = 'localhost';
    message.content = this.content;

    this.sent.push(message);
    this.scannerServiceR.messages.next("1100");
  }
  /**
   * Ejecuta el servicio para subir todos los documentos escaneados
   *
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  ScannDocOptions(documentScan?: Blob): any {
    if (documentScan) {
      let checkFuction = find(this.rowSelected.data.funciones, { funcion: Const.DOCUMENTS_FUNCTIONS.insertSticker })
      if (checkFuction) {
        this.selectedSticker = null;
        this.selectorDataSticker.length = 0;
        this.srds.getStickers(this.rowSelected.data.id_tipo_documental).subscribe(async (res) => {
          if (res) {
            res.forEach(async (r) => {
              if (!r.imprimir) {
                let name = await r.nombre;
                let item = {
                  id: r.id,
                  nombre: name,
                };
                this.selectorDataSticker.push(item);
              }
            });
          }
          this.modalRef = this.modal.show(this.templateStikersDocScanned, {
            class: "modal-lg-personalized",
            ignoreBackdropClick: true,
          });
          this.modalRef.content = documentScan;
        });
      }
      else {
        this.uploadScannDoc(documentScan, false);
      }
    }
  }

  /**
   * Ejecuta el servicio para subir todos los documentos escaneados
   *
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  uploadScannDoc(documentScan?: Blob, stiker?: boolean): any {
    if (documentScan) {
      if (stiker && !this.task.carga) {
        if (this.selectedSticker) {
          this.formData.append("insertar_sticker", JSON.stringify(true));
          this.formData.append("stiker_id", JSON.stringify(this.selectedSticker));
        }
        else {
          this.toastr.warning("Debe seleccionar un roluto", "Información faltante");
        }
      } else if (stiker && this.task.carga) {
        if (this.selectedSticker) {
          this.formData.append("insertar_sticker", JSON.stringify(true));
          this.formData.append("stiker_id", JSON.stringify(this.selectedSticker));
        }
      }
      let replace = false;
      this.formData.append(this.rowSelected.data.tipo_documental + ".pdf", documentScan);
      this.formData.append('documento_escaneado', "true");
      if (!replace) {
        const dataD = {
          file: this.rowSelected.data.tipo_documental + ".pdf",
          id_tarea: this.rowSelected.data.idtarea,
          clasificacion: "",
          tipo_documento_id: this.rowSelected.data.id_tipo_documental,
          id_documento: this.rowSelected.data.documentos_detalle[0].id_documento,
          radicado: this.rowSelected.data.documentos_detalle[0].radicado,
        };
        this.documentsUpload.push(dataD);
        this.uploadDocs();
      }
    }
  }

  /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof RadicationDocsComponent
   */
  closeModalPreviewDocScann() {
    this.confirmRef.new({
      question: '¿Desea guardar el archivo escaneado?',
      labelConfirm: 'Sí',
      labelDecline: 'No'
    }).then(resp => {
      if (resp) {
        this.modalRef.hide();
        this.ScannDocOptions(this.modalRef.content['blob_file']);
      }
      else {
        this.modalRef.hide()
        this.modalRef = this.modal.show(this.modalDetail, {
          class: "modal-lg-personalized",
          ignoreBackdropClick: true,
        });
      }
    })
  }

  /**
+   * cierra el modal de carga
+   *
+   * @memberof CreationDynamicComponentComponent
+   */
  closeModalLoadDoc() {
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }


  /**
   * Genera el documento seleccionado
   *
   * @private
   * @param {*} data
   * @memberof SpecialRadicationComponent
   */
  generateDocument() {
    const dataDocument = {
      tarea: this.rowSelected.data.idtarea,
      tipo_documental: this.rowSelected.data.id_tipo_documental
    };

    this.srds.generateDocument(dataDocument).subscribe(file => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = file.url.path;
      a.download = file.url.name;
      a.click();
      a.remove();
    });

  }

  /**
   *Abre la modal de historial de documentos
   *
   * @memberof SpecialRadicationComponent
   */
  openHistoryModifyDocumentModal() {
    this.closeModal();
    this.rowSelectModify = this.rowSelected.data.documentos_detalle[0].id_documento;
    let source: any[] = [];
    this.srds.getHistoryModifyDocument(this.rowSelectModify).subscribe(async (res) => {
      if (res) {
        res.forEach(async (r) => {
          if (r.fecha) {
            const date = new Date(r.fecha);
            r.fecha = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
          }
          if (r.fecha_aprobacion) {
            const date = new Date(r.fecha_aprobacion);
            r.fecha_aprobacion = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
          }
          source.push(r);
        });
      }
      this.modalRef = this.modal.show(this.historyModify, { class: 'modal-personalized', initialState: this.rowSelectModify, ignoreBackdropClick: true, });
      this.sourceDataHistoryModify = new LocalDataSource(source);
      const docsC = new SpecialRadicationConfig();
      this.settingsHistoryModify = docsC.settingsHistoryModify;
      docsC.accionModify.subscribe(async (data: any) => {
        this.accionTableModify(data);
      });
      let modalContent = {
        settingsModify: this.settingsHistoryModify,
        source: this.sourceDataHistoryModify
      };
      this.modalRef.content = modalContent;
    });
  }

  /**
     * Define la accion a realizar dependiendo de la opcion seleccionada en la tabla
     *
     * @private
     * @param {*} data
     * @returns {*}
     * @memberof SpecialRadicationComponent
     */
  private accionTableModify(data: any): any {
    if (data.accion === 'download') {
      this.downloadModify(data.data);
    } else if (data.accion === 'preview') {
      this.previewModify(data.data);
    }
    else if (data.accion === 'error') {
      this.toastr.error(data.message, 'Error de accion');
    }
  }

  /**
    * Desacarga el archivo del documento selecionado
    *
    * @private
    * @param {*} data
    * @returns {*}
    * @memberof SpecialRadicationComponent
    */
  private downloadModify(data: number): any {
    this.srds.dowloadModifyFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  /**
   * previsulizar el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof SpecialRadicationComponent
   */
  private previewModify(data: number): any {
    this.srds.dowloadModifyFile(data).subscribe((res: any) => {
      this.modalRef.hide();
      this.modalRef = this.modal.show(this.templatePreviewModifyDoc, { class: 'modal-personalized', initialState: res.file });
      let type = res.file.path.split(".").pop();
      let document = {
        "tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url=" + res.file.path + "&embedded=true",
        "rutaMicrosoft": "https://view.officeapps.live.com/op/view.aspx?src=" + res.file.path + "&wdOrigin=BROWSELINK"
      }
      this.modalRef.content = document;
    });
  }

  /**
     * cierra el modal con el la previsualizacion de documento
     *
     * @memberof SpecialRadicationComponent
     */
  closeModalPreviewModifyDoc() {
    this.modalRef.hide();
    this.openHistoryModifyDocumentModal();
  }

  /**
   *Cierra la modal de subir documentos
   *
   * @memberof SpecialRadicationComponent
   */
  closeDocumentsHistoryModifyModal() {
    this.closeModal();
    this.sourceDataHistoryModify = new LocalDataSource([]);
    this.modalRef = this.modal.show(this.modalDetail, {
      class: "modal-lg-personalized",
      ignoreBackdropClick: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/special-radication/special-radication.component.ts